'use client';
import React, { useState } from 'react';
import AppLogo from '@/components/ui/AppLogo';

const TERMS_SECTIONS = [
  {
    title: 'Booking & Payment',
    body: 'Full payment is required to secure your session date. Refunds are available up to 24 hours before the scheduled shoot time.',
  },
  {
    title: 'Cancellations',
    body: 'Cancellations within 24 hours of the session will be charged the full amount.',
  },
  {
    title: 'Rescheduling',
    body: 'Rescheduling is available up to 24 hours before scheduled shoot.',
  },
  {
    title: 'Image Delivery',
    body: 'You will receive a gallery of edited digital images within 7 days. Exact number depends on the package.',
  },
  {
    title: 'Printing',
    body: 'Request of a physical print order has an additional fee.',
  },
  {
    title: 'Usage',
    body: 'Regal Portraits reserves the right to use any photographs for gallery images, social media advertisements, and example images. Customers will be notified if their photos will be used as such, but are entitled to deny the use of their photos.',
  },
  {
    title: 'Liability',
    body: 'Our liability is limited to the amount paid for the session. We are not responsible for acts of God or circumstances beyond our control.',
  },
  {
    title: 'Agreement',
    body: 'Upon booking of a session, all terms are agreed to by the customer.',
  },
];

export default function Footer() {
  const [showTerms, setShowTerms] = useState(false);

  return (
    <>
      <footer
        className="border-t py-10 px-6"
        style={{ borderColor: 'rgba(139,105,20,0.18)' }}
      >
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
          <AppLogo
            src="/assets/images/ChatGPT_Image_Aug_7__2026__05_33_41_PM-1786149255665.png"
            text="REGAL PORTRAITS"
            size={32}
            className="font-display font-black tracking-[0.25em] text-base"
          />

          <div className="flex items-center gap-8">
            {['Packages', 'Book', 'Privacy', 'Terms'].map((link, i, arr) => (
              <React.Fragment key={link}>
                <a
                  href={link === 'Book' ? '#reserve' : link === 'Packages' ? '#packages' : '#'}
                  onClick={link === 'Terms' ? (e) => { e.preventDefault(); setShowTerms(true); } : undefined}
                  className="text-xs font-medium tracking-wide transition-colors duration-200 cursor-pointer"
                  style={{ color: 'rgba(232,228,220,0.4)' }}
                  onMouseEnter={(e) => ((e.target as HTMLAnchorElement).style.color = '#D4A843')}
                  onMouseLeave={(e) => ((e.target as HTMLAnchorElement).style.color = 'rgba(232,228,220,0.4)')}
                >
                  {link}
                </a>
                {i < arr.length - 1 && (
                  <span style={{ color: 'rgba(139,105,20,0.3)', fontSize: '10px' }}>·</span>
                )}
              </React.Fragment>
            ))}
          </div>

          <div className="flex items-center gap-5">
            {[
              { label: 'Instagram', icon: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z' },
              { label: 'SoundCloud', icon: 'M1.175 12.225c-.015 0-.023.01-.023.025l-.556 3.485c0 .015.008.025.023.025.015 0 .023-.01.023-.025l.556-3.485c0-.015-.008-.025-.023-.025zm-.855.8c-.014 0-.023.01-.023.026L0 15.536c0 .015.01.025.023.025.014 0 .023-.01.023-.025l.297-2.485c0-.016-.01-.026-.023-.026zm1.738-.532c-.014 0-.023.01-.023.024l-.7 4.21c0 .014.01.024.023.024.014 0 .023-.01.023-.024l.7-4.21c0-.014-.01-.024-.023-.024zm.9-.224c-.013 0-.022.01-.022.023l-.81 4.866c0 .014.01.024.022.024.013 0 .022-.01.022-.024l.81-4.866c0-.013-.01-.023-.022-.023zm.9.1c-.013 0-.022.01-.022.023l-.73 4.39c0 .014.01.023.022.023.013 0 .022-.01.022-.023l.73-4.39c0-.014-.01-.023-.022-.023zm.9.05c-.013 0-.023.01-.023.023l-.65 3.9c0 .013.01.023.023.023.013 0 .022-.01.022-.023l.65-3.9c0-.013-.01-.023-.022-.023zm1.8-.15c-.013 0-.022.01-.022.023l-.57 3.43c0 .013.01.023.022.023.013 0 .022-.01.022-.023l.57-3.43c0-.013-.01-.023-.022-.023zm.9.1c-.013 0-.022.01-.022.023l-.49 2.94c0 .013.01.023.022.023.013 0 .022-.01.022-.023l.49-2.94c0-.013-.01-.023-.022-.023zm.9-.1c-.013 0-.022.01-.022.022l-.41 2.47c0 .013.01.022.022.022.013 0 .022-.01.022-.022l.41-2.47c0-.013-.01-.022-.022-.022zm.9.15c-.013 0-.022.01-.022.022l-.33 2c0 .013.01.022.022.022.013 0 .022-.01.022-.022l.33-2c0-.013-.01-.022-.022-.022zm.9.1c-.013 0-.022.01-.022.022l-.25 1.5c0 .013.01.022.022.022.013 0 .022-.01.022-.022l.25-1.5c0-.013-.01-.022-.022-.022zm.9-.15c-.013 0-.022.01-.022.022l-.17 1c0 .013.01.022.022.022.013 0 .022-.01.022-.022l.17-1c0-.013-.01-.022-.022-.022zm.9.1c-.013 0-.022.01-.022.022l-.09.54c0 .013.01.022.022.022.013 0 .022-.01.022-.022l.09-.54c0-.013-.01-.022-.022-.022z' },
            ].map(({ label, icon }) => (
              <a
                key={label}
                href={label === 'Instagram' ? 'https://www.instagram.com/regal_portraits/?hl=en' : '#'}
                target={label === 'Instagram' ? '_blank' : undefined}
                rel={label === 'Instagram' ? 'noopener noreferrer' : undefined}
                aria-label={label}
                className="transition-opacity duration-200 hover:opacity-100"
                style={{ opacity: 0.35 }}
                onMouseEnter={(e) => ((e.currentTarget as HTMLAnchorElement).style.opacity = '1')}
                onMouseLeave={(e) => ((e.currentTarget as HTMLAnchorElement).style.opacity = '0.35')}
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-4 h-4"
                  style={{ color: '#D4A843' }}
                >
                  <path d={icon} />
                </svg>
              </a>
            ))}
          </div>

          <p
            className="text-xs"
            style={{ color: 'rgba(232,228,220,0.25)', letterSpacing: '0.05em' }}
          >
            © 2026 Regal Portraits
          </p>
        </div>

        <div className="max-w-7xl mx-auto mt-4 flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-6">
          <a
            href="tel:+15098684990"
            className="text-xs tracking-wide transition-colors duration-200"
            style={{ color: 'rgba(232,228,220,0.45)' }}
            onMouseEnter={(e) => ((e.currentTarget as HTMLAnchorElement).style.color = '#D4A843')}
            onMouseLeave={(e) => ((e.currentTarget as HTMLAnchorElement).style.color = 'rgba(232,228,220,0.45)')}
          >
            (509) 868-4990
          </a>
          <span style={{ color: 'rgba(139,105,20,0.3)', fontSize: '10px' }} className="hidden sm:inline">·</span>
          <a
            href="mailto:Zach@regal-portraits.com"
            className="text-xs tracking-wide transition-colors duration-200"
            style={{ color: 'rgba(232,228,220,0.45)' }}
            onMouseEnter={(e) => ((e.currentTarget as HTMLAnchorElement).style.color = '#D4A843')}
            onMouseLeave={(e) => ((e.currentTarget as HTMLAnchorElement).style.color = 'rgba(232,228,220,0.45)')}
          >
            Zach@regal-portraits.com
          </a>
        </div>
      </footer>

      {/* Terms Modal */}
      {showTerms && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ backgroundColor: 'rgba(0,0,0,0.75)' }}
          onClick={() => setShowTerms(false)}
        >
          <div
            className="relative w-full max-w-lg max-h-[80vh] overflow-y-auto rounded-lg p-8"
            style={{ backgroundColor: '#0f0e0c', border: '1px solid rgba(139,105,20,0.3)' }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              onClick={() => setShowTerms(false)}
              className="absolute top-4 right-4 transition-opacity duration-200"
              style={{ color: 'rgba(232,228,220,0.4)' }}
              onMouseEnter={(e) => ((e.currentTarget as HTMLButtonElement).style.color = '#D4A843')}
              onMouseLeave={(e) => ((e.currentTarget as HTMLButtonElement).style.color = 'rgba(232,228,220,0.4)')}
              aria-label="Close"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <h2
              className="text-lg font-semibold tracking-widest mb-6"
              style={{ color: '#D4A843', fontFamily: 'var(--font-display, serif)' }}
            >
              TERMS & CONDITIONS
            </h2>

            <div className="space-y-5">
              {TERMS_SECTIONS.map(({ title, body }) => (
                <div key={title}>
                  <p
                    className="text-xs font-semibold tracking-widest mb-1"
                    style={{ color: '#D4A843' }}
                  >
                    {title.toUpperCase()}
                  </p>
                  <p
                    className="text-sm leading-relaxed"
                    style={{ color: 'rgba(232,228,220,0.7)' }}
                  >
                    {body}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}